import React from 'react'
import styled from 'styled-components'

import { AccountDocumentType } from '../../../../../graphql/search'
import { PractitionerSettings } from '../../../../../lib/practitioner-settings/types'
import Link from '../../../../global/Link'
import { AccountDocumentForm } from './AccountDocumentForm'

import downloadIcon from '../../../../../img/account_document_upload_icons/download-icon.svg'

export interface W9TaxpayerIdentificationProps {
  className?: string
  settings: PractitionerSettings
}

const StyledHeader = styled.h4`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-size: 18px;
  color: #001b36;
`

const StyledDescription = styled.p`
  && {
    font-family: ${({ theme }) => theme.fontFamilies.roboto};
    font-size: 1rem;
    margin-bottom: 1rem;
  }
`

const DownloadIcon = styled.img`
  height: 16px;
  width: 16px;
  margin-right: 8px;
`

const DownloadLink = styled(Link)`
  && {
    display: inline-flex;
    align-items: center;
    font-family: ${({ theme }) => theme.fontFamilies.roboto};
    font-size: 0.875rem;
    padding-bottom: 1rem;
    color: ${({ theme }) => theme.colors.text.primary};
  }
`
export const W9TaxpayerIdentification: React.FC<W9TaxpayerIdentificationProps> = ({
  className,
  settings,
}) => {
  return (
    <section className={className}>
      <StyledHeader>W-9 Taxpayer Identification Form</StyledHeader>
      <StyledDescription>
        Download and complete the form as required by the IRS. Be sure to sign your form before
        uploading. Changes may take up to one business day to go into effect.
      </StyledDescription>
      <DownloadLink to={'https://www.irs.gov/pub/irs-pdf/fw9.pdf'} target="_blank">
        <DownloadIcon src={downloadIcon} />
        Download W-9 form
      </DownloadLink>
      <AccountDocumentForm documentType={AccountDocumentType.W9TaxId} settings={settings} />
    </section>
  )
}
